module.exports = __webpack_public_path__ + "static/netlify-functions-thumb-b70b9b15aee4de80a0f7ae1b1861deb0.jpg";